export class IBANDto {
  iban: string;
}
